import { render, staticRenderFns } from "./LayoutsTab.vue?vue&type=template&id=1bdbacb6"
import script from "./LayoutsTab.vue?vue&type=script&lang=js"
export * from "./LayoutsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports